import { getUUID } from '@src/utils/uuid';
import { TYPE_URLS } from './consts';

export const getFileObjects = (filteredAcceptedFiles) => {
  return filteredAcceptedFiles.map((f) => {
    const uuid = getUUID();
    f.uuid = uuid;
    f.loadingError = false;
    return {
      uuid,
      loading: true,
      loadingError: false,
      fileSize: f.size,
      originalName: f.name,
      originalFile: f,
      previewUrl: getPreviewUrl(f),
    };
  });
};

export const getPreviewUrl = (file) => {
  const extension = file.name.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'gif':
    case 'svg':
      return URL.createObjectURL(file);
    case 'doc':
    case 'docx':
      return TYPE_URLS.doc;
    case 'xls':
    case 'xlsx':
      return TYPE_URLS.xlsx;
    case 'pdf':
      return TYPE_URLS.pdf;
    case 'zip':
      return TYPE_URLS.zip;
    default:
      return TYPE_URLS.other;
  }
};
